import { createReducer, on } from '@ngrx/store';
import { Lot } from 'src/app/components/bids-and-offers/lots.model';
import { lotNegotiationData, selectLot } from './lot.actions';
import { NegotiationDetails } from 'src/app/components/negotiations/negotiations.model';


export interface LotState{
  lot: Lot | null;
  negotiationDetails: NegotiationDetails[] | [];
}

export const initialLotState: LotState = {
  lot: null,
  negotiationDetails: [],
};

export const lotReducer = createReducer(
  initialLotState,
  on( selectLot, (state, {lotDetails}) => ({...state, lot: {...lotDetails}, negotiationDetails: [] })),
  on( lotNegotiationData, (state, {negotiations}) => ({...state, negotiationDetails: [...negotiations]}))
);